
export class DocMenus {
  modulo: string;
  path?: string;
  icon: string;
  nombre?: string;
  visible?: boolean;
}

export class DocAccess {
  nombre: string;
  accesos: DocMenus[]
  icon: string;
}





export const MENUS: DocAccess[] = [
  {
    nombre: "Catalogos",
    icon: 'reorder',
    accesos: [
      {
        modulo: 'BANNERS',
        path: '/banners',
        icon: 'view_carousel',
        visible: true
      }
    ]
  }, {
    nombre: "Operaciones",
    icon: 'check_box',
    accesos: [
      {
        modulo: 'VENTAS',
        path: '/sale',
        icon: 'attach_money',
        visible: true
      },
      {
        modulo: 'ACTIVACIONES_Y_RECARGAS',
        path: '/security/activation',
        icon: 'check_circle',
        visible: true
      },
      {
        modulo: 'QR',
        path: '/qr',
        icon: 'gradient',
        visible: true
      }
    ]
  }, {
    nombre: 'Reportes',
    icon: 'gradient',
    accesos: [
      {
        modulo: 'REPORTE_DE_RECARGAS',
        path: '/security/recargas/reportes',
        icon: 'gradient',
        visible: true
      },
      {
        modulo: 'CONSULTAS',
        path: '/reports/queries',
        icon: 'find_in_page',
        visible: true
      },
      {
        modulo: 'INVENTARIO_POR_VENDEDOR',
        path: '/reports/inventory-seller',
        icon: 'recent_actors',
        visible: true
      }, {
        modulo: 'REPORTE_DE_VENTA',
        path: '/reports/reportSell',
        icon: 'insert_chart',
        visible: true
      }, {
        modulo: 'REPORTE_ESTATUS_POR_SERIE',
        path: '/reports/reportStatus',
        icon: 'insert_chart',
        visible: true
      }, {
        modulo: 'REPORTE_ACTIVACIONES',
        path: '/reports/activations',
        icon: 'insert_chart',
        visible: true
      }, {
        modulo: 'USUARIO_ACTIVO',
        path: '/reports/activo',
        icon: 'insert_chart',
        visible: true
      }, {
        modulo: 'CADENAS_COMERCIALES',
        path: '/reports/comercial-chains',
        icon: 'storefront',
        visible: true
      },


      {
        modulo: 'FACTURACION',
        path: '/reports/facturation',
        icon: 'description',
        visible: true
      },

      {
        modulo: 'IMPORTACION',
        path: '/reports/tabledate',
        icon: 'list',
        visible: true
      },


    ]
  }, {
    nombre: 'Seguridad',
    icon: 'security',
    accesos: [
      {
        modulo: 'USUARIOS',
        path: '/security/users',
        icon: 'people',
        visible: true
      },
      {
        modulo: 'ROLES_Y_PERMISOS',
        path: '/security/rolls',
        icon: 'people',
        visible: true
      },
      {
        modulo: 'CHANGE_PASSWORD',
        path: '/security/change-password',
        icon: 'lock',
        visible: true
      }

    ]
  }







];

